<template>
    <div
        class="contact-note"
        ref="note"
        :class="{
            'private-note': note.isPrivate,
        }"
    >
        <div class="contact-note-agent-avatar" v-if="note.createdUser">
            <AgentAvatar :userID="note.createdUser._id" :size="30" />
        </div>
        <div class="contact-note-content">
            <div class="contact-note-details">
                <div class="contact-note-details-title">
                    <div class="contact-note-agent-name">
                        <div class="contact-note-agent-name">{{ note.createdUser.name }}</div>
                        <div
                            class="material-icons"
                            v-if="note.isPrivate"
                            v-tippy="{ placement: 'left-center' }"
                            :content="'This only showing you.'"
                        >
                            vpn_lock
                        </div>
                    </div>
                    <div class="contact-note-more-actions">
                        <a-popover
                            v-model="isPopoverVisible"
                            trigger="click"
                            placement="bottomRight"
                            overlayClassName="contact-note-popover"
                        >
                            <template #content>
                                <div class="more-actions">
                                    <div class="action-button" @click="markPrivateOrPublic">
                                        <div class="action-button-icon">
                                            <div class="material-icons">
                                                {{ note.isPrivate ? "public" : "vpn_lock" }}
                                            </div>
                                        </div>
                                        <div class="action-button-text">
                                            {{ note.isPrivate ? $t("message.showNote") : $t("message.hideNote") }}
                                        </div>
                                    </div>
                                    <div class="action-button" @click="updatingNote = true">
                                        <div class="action-button-icon">
                                            <div class="material-icons">settings</div>
                                        </div>
                                        <div class="action-button-text">
                                            {{ $t("message.updateNote") }}
                                        </div>
                                    </div>
                                    <div class="action-button" @click="deleteMode = true">
                                        <div class="action-button-icon">
                                            <div class="material-icons">delete</div>
                                        </div>
                                        <div class="action-button-text">
                                            {{ $t("message.delete") }}
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <div v-if="!updatingNote" class="material-icons">more_vert</div>
                        </a-popover>
                        <div v-if="updatingNote" @click.stop="updatingNote = false" class="material-icons">close</div>
                    </div>
                </div>
                <div class="contact-notes-form" v-if="updatingNote">
                    <a-textarea
                        class="non-resizable"
                        v-model="description"
                        :auto-size="{ minRows: 2, maxRows: 10 }"
                        style="width: 95%"
                    />
                    <div class="contact-notes-form-actions">
                        <div></div>
                        <div class="contact-notes-update-buttons">
                            <div class="note-button note-update-cancel" @click="updatingNote = null">
                                {{ $t("message.cancel") }}
                            </div>
                            <div class="note-button note-update-ok" @click="makeUpdateNote">
                                {{ $t("message.update") }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contact-note-details-description" v-else>
                    {{ note.description }}
                </div>
                <div class="contact-note-details-date">
                    {{
                        note.updatedAt
                            ? new Date(note.updatedAt).toLocaleDateString() +
                              " - " +
                              new Date(note.updatedAt).toLocaleTimeString("tr-TR", { hour12: false })
                            : new Date(note.createdAt).toLocaleDateString() +
                              " - " +
                              new Date(note.createdAt).toLocaleTimeString("tr-TR", { hour12: false })
                    }}
                </div>
            </div>
            <div class="note-action-button" v-if="deleteMode">
                <div class="note-delete-button note-button" @click="deleteNote">
                    {{ $t("message.delete") }}
                </div>
                <div class="note-update-button note-button" @click="deleteMode = false">
                    {{ $t("message.cancel") }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import SupsisButton from "../../../views/Pages/Settings/components/SupsisButton.vue";
import AgentAvatar from "../../common/AgentAvatar.vue";

export default {
    name: "ContactNoteItem",
    components: { AgentAvatar, SupsisButton },
    props: {
        visitorId: {
            type: String,
            required: true,
        },
        note: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        deleteMode: false,
        isPrivate: false,
        description: null,
        isCreatingActive: false,
        updatingNote: null,
        isPopoverVisible: false,
        isExpanded: false,
        openedNoteId: null,
    }),
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        ...mapActions({
            createNote: "visitor/createVisitorNote",
            updateNote: "visitor/updateVisitorNote",
            getNotes: "visitor/getVisitorNotes",
            deleteVisitorNote: "visitor/deleteVisitorNote",
        }),
        markPrivateOrPublic() {
            this.updateNote({
                visitorId: this.visitorId,
                noteId: this.note._id,
                payload: {
                    isPrivate: !this.note.isPrivate,
                },
            }).then((body) => {
                this.$message.success(
                    this.note.isPrivate
                        ? "Kullanıcı notu artık herkese açık."
                        : "Kullanıcı notu artık sadece sizin için görünür."
                ); // todo translate
                this.$emit("note-updated", {
                    ...this.note,
                    isPrivate: !this.note.isPrivate,
                });
            });
        },
        deleteNote() {
            this.deleteVisitorNote(this.note._id).then(() => {
                this.$emit("note-deleted", this.note._id);
                this.$message.success("Kullanıcı notu başarıyla silindi."); // todo translate
            });
        },
        makeUpdateNote() {
            this.updateNote({
                visitorId: this.visitorId,
                noteId: this.note._id,
                payload: {
                    ...this.note,
                    description: this.description,
                },
            }).then(() => {
                this.$refs.note.classList.add("successfully");
                setTimeout(() => {
                    this.$refs.note.classList.remove("successfully");
                }, 1000);
                this.$message.success("Kullanıcı notu başarıyla güncellendi."); // todo translate
                this.$emit("note-updated", {
                    ...this.note,
                    description: this.description,
                });
                this.updatingNote = null;
            });
        },
    },
    watch: {
        updatingNote: {
            handler(val) {
                if (val) {
                    this.isPopoverVisible = false;
                    this.description = this.note.description;
                }
            },
        },
        deleteMode: {
            handler(val) {
                if (val) {
                    this.isPopoverVisible = false;
                }
            },
        },
    },
};
</script>
<style lang="scss">
.note-button {
    border-radius: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
}

.note-delete-button {
    width: 30%;
    background-color: #ff5050;
    color: white;
}

.note-update-button {
    width: 60%;
    background-color: #f1f4f7;
    color: #647491;
}

.contact-notes-update-buttons {
    width: 95%;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    align-items: center;
    height: 30px;
    cursor: pointer;

    .note-update-ok {
        height: 100%;
        background-color: #22272d;
        color: white;
        width: 30%;
        margin-right: 15px;
    }

    .note-update-cancel {
        height: 100%;
        background-color: #f1f4f7;
        color: #647491;
        width: 30%;
    }
}

.contact-note-popover {
    .ant-popover-arrow {
        display: none !important;
    }

    .ant-popover-inner-content {
        box-shadow: none !important;
        border: 1px solid var(--border-neutral-default);
        border-radius: 4px;
        padding: 0 !important;

        .more-actions {
            overflow: hidden;

            :not(:last-child).action-button {
                border-bottom: 1px solid var(--border-neutral-default);
            }

            .action-button {
                display: flex;
                align-items: center;
                padding: 4px 10px;
                gap: 4px;
                cursor: pointer;

                &:hover {
                    background: #22272d;
                    border-radius: 4px;

                    .action-button-icon {
                        .material-icons {
                            color: white;
                        }
                    }

                    .action-button-text {
                        color: white;
                    }
                }

                &-icon {
                    line-height: 0;

                    .material-icons {
                        font-size: 18px;
                    }
                }

                &-text {
                    font-size: 16px;
                }
            }
        }
    }
}

@keyframes success {
    0% {
        background-color: #9dfaab;
    }
    100% {
        background-color: white;
    }
}

.contact-note {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 8px;

    &.successfully {
        animation: success 1s;
    }

    &.private-note {
        background-color: rgb(253, 255, 104); // todo set to attribute
    }

    .contact-note-content {
        display: flex;
        flex-direction: column;
        gap: 5px;
        width: 100%;

        .contact-note-details-date {
            font-size: 12px;
            color: #647491;
        }
    }

    .note-action-button {
        display: flex;
        justify-content: flex-start;
        width: 100%;
        gap: 8px;
        height: 30px;
    }

    .note-update-cancel {
    }

    .note-update-ok {
    }

    &-agent-avatar {
        width: 30px;
        height: 30px;
        border-radius: 30px;
    }

    &-details {
        display: flex;
        flex-direction: column;
        gap: 3px;
        width: 100%;

        &-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;

            .contact-note-agent-name {
                font-size: 16px;
                display: flex;
                align-items: center;
                font-weight: bold;
                gap: 4px;

                .material-icons {
                    font-size: 16px;
                    line-height: 0;
                    user-select: none;
                }
            }

            .contact-note-more-actions {
                .material-icons {
                    cursor: pointer;
                    width: 20px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                }
            }
        }

        &-description {
            border-radius: 4px;
            max-height: 60px;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }
}

.non-resizable {
    resize: none !important;
}
</style>
